import Modifier from 'ember-modifier'
import { service } from '@ember/service'
import type TeacherEvents from 'teacher-ui-client/services/teacher-events'
import { registerDestructor } from '@ember/destroyable'
import type Owner from '@ember/owner'
import type { ArgsFor } from 'ember-modifier'

interface Signature {
  Args: {
    Named: {
      eventData: Record<PropertyKey, any>
    }
    Positional: [string, string]
  }
  Element: HTMLElement
}

const DEFAULT_THRESHOLD_TIME = 20000 // 20 seconds

export class teacherViewedEvent extends Modifier<Signature> {
  @service teacherEvents!: TeacherEvents

  viewportEnterObservationEntry: Nullable<IntersectionObserverEntry> = null

  eventData: Record<PropertyKey, any> = {}
  eventName: string = ''
  product: string = ''

  observeCallback = (entries: IntersectionObserverEntry[], _observer: IntersectionObserver) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Element entered viewport start tracking
        this.viewportEnterObservationEntry = entry
      } else if (this.viewportEnterObservationEntry !== null) {
        // Element left viewport - calculate viewing time
        const viewingTime = entry.time - this.viewportEnterObservationEntry.time

        if (viewingTime > DEFAULT_THRESHOLD_TIME) {
          this.sendTeacherEvent(viewingTime)
        }
        this.viewportEnterObservationEntry = null
      }
    })
  }

  observer = new IntersectionObserver(this.observeCallback, { threshold: 0.9 })

  modify(
    element: Signature['Element'],
    [eventName, product]: Signature['Args']['Positional'],
    { eventData }: Signature['Args']['Named'],
  ) {
    this.eventName = eventName
    this.product = product
    this.eventData = eventData

    this.observer.observe(element)
  }

  constructor(owner: Owner, args: ArgsFor<Signature>) {
    super(owner, args)

    registerDestructor(this, this.cleanup)
  }

  sendTeacherEvent = (viewingTime: number) => {
    this.teacherEvents.sendEvent(this.eventName, this.product, { ...this.eventData, viewingTime })
  }

  cleanup = () => {
    this.observer.disconnect()
  }
}
